const MESSAGES_KEY = 'chat_messages';

const msgs = {
    messages: JSON.parse(localStorage.getItem(MESSAGES_KEY)) || [],
    addMessage: function(message) {
        this.messages.push(message);
        localStorage.setItem(MESSAGES_KEY, JSON.stringify(this.messages));
    }
};

export default msgs;